import Axios, { AxiosInstance } from 'axios'
import { apiConstants, ApiConstantsInterface } from '../constants/api.constants'
import { CalendarSettingsInterface } from '@plugin/Common/interfaces/calendar-settings.interface'

interface AspenwareCommerceSettingsServiceInterface {
  getCalendarSettings(): Promise<CalendarSettingsInterface>
  updateCalendarSettings(settings: CalendarSettingsInterface): Promise<CalendarSettingsInterface>
}

class AspenwareCommerceSettingsService implements AspenwareCommerceSettingsServiceInterface {
  protected axios: AxiosInstance

  protected config: ApiConstantsInterface

  constructor(config: ApiConstantsInterface) {
    this.config = config
    this.axios = Axios.create({
      baseURL: config.commerceBaseUrl,
    })
  }

  async getCalendarSettings(): Promise<CalendarSettingsInterface> {
    const response = await this.axios.get(`${this.config.calendarSettings}`)
    return response.data
  }

  async updateCalendarSettings(settings: CalendarSettingsInterface) {
    const response = await this.axios.post(`${this.config.calendarSettings}`, settings)
    return response.data
  }
}

const aspenwareCommerceSettingsService = new AspenwareCommerceSettingsService(apiConstants)
export { aspenwareCommerceSettingsService }
